import type { BaseEntity } from "../../UniversalCRMTable/types/shared";

export interface DetailHeaderEntityData {
  entityType: string;
  tags: unknown[];
  status: string | null;
  priority: string | null;
  fields: {
    company?: string;
    email?: string;
    phone?: string;
    title?: string;
    ticketNumber?: string;
    category?: string;
    assignedTo?: string;
    dueDate?: string;
    role?: string;
    department?: string;
  };
}

/**
 * Shared shaping logic for detail header data.
 * Keeps desktop and mobile detail modal header behavior aligned.
 */
export function buildDetailHeaderEntityData<T extends BaseEntity>(
  item: T,
  entityType: string
): DetailHeaderEntityData {
  const tags = item.tags && Array.isArray(item.tags) ? item.tags : [];

  // Mirror the logic from EnhancedUniversalDetailHeader to avoid String(undefined) → "undefined"
  let statusString: string | null = null;
  if (entityType === "deals" && item.stage != null) {
    // Deals use `stage` as their status-equivalent field
    statusString = String(item.stage);
  } else {
    const rawStatus = item.status || item.state || item.priority;
    if (rawStatus != null) {
      statusString =
        typeof rawStatus === "string" || typeof rawStatus === "number" || typeof rawStatus === "boolean"
          ? String(rawStatus)
          : null;
    }
  }

  const priority = item.priority;
  const priorityString = priority ? String(priority) : null;

  return {
    entityType,
    tags,
    status: statusString,   // null when no status-like field exists → badge is hidden
    priority: priorityString,
    fields: {
      company: item.company_name != null ? String(item.company_name) : undefined,
      email: item.email != null ? String(item.email) : undefined,
      phone: item.phone != null ? String(item.phone) : undefined,
      title: item.title != null ? String(item.title) : undefined,
      ticketNumber: item.ticket_number != null ? String(item.ticket_number) : undefined,
      category: item.category != null ? String(item.category) : undefined,
      assignedTo: item.assigned_to != null ? String(item.assigned_to) : undefined,
      dueDate: item.due_date != null ? String(item.due_date) : undefined,
      role: item.role != null ? String(item.role) : undefined,
      department: item.department != null ? String(item.department) : undefined,
    },
  };
}
